<template>
  <el-card shadow="never"
           class="aui-card--fill">
              <el-form label-position="top"
               label-width="45px"
               :model="inServForm"
               ref="inServForm">
               <!--面授课程 -->
                <el-form-item label="" >
                   <el-col :span="24">
                     <span color="#abaeb5">{{$t('offering.courseNameCncan')}}：</span>
                     <!-- <el-form-item prop="courseNameCn" :label="$t('offering.courseNameCncan')" style="width: 60px; padding-left: 2.5px;">
                                    <el-input  disabled
                                    placeholder=""
                                    v-model="inServForm.courseNameCn">
                               </el-input>
                    </el-form-item> -->
                    <span color="#abaeb5">{{inServForm.courseNameCn}}</span>
                    </el-col>
                </el-form-item>
               <!--报名人数 -->
                <el-form-item label="" style="margin-top:10px;">
                   <el-col :span="10">
                     <span color="#abaeb5">{{$t('offering.registNumbercan')}}：</span>
                     <span color="#abaeb5">{{inServForm.registNumber}}</span>
                                <!-- <el-form-item prop="registNumber" :label="$t('offering.registNumbercan')" style="width: 60px; padding-left: 2.5px;">
                                    <el-input  disabled
                                    placeholder=""
                                    v-model="inServForm.registNumber">
                               </el-input>
                    </el-form-item> -->
                    </el-col>
                </el-form-item>
                <!--已加入等候名单 -->
                <el-form-item label="" style="margin-top:10px;">
                   <el-col :span="24">
                    <span color="#abaeb5">{{$t('offering.waitingnumbercan')}}：</span>
                    <span color="#abaeb5">{{inServForm.waitingnumber}}</span>
                       <!--         <el-form-item prop="waitingnumber" :label="$t('offering.waitingnumbercan')" style="width: 60px; padding-left: 2.5px;">
                                    <el-input  disabled
                                    placeholder=""
                                    v-model="inServForm.waitingnumber">
                               </el-input>
                    </el-form-item> -->
                    </el-col>
                </el-form-item>
               <!--培训日期 -->
                <el-form-item label="" style="margin-top:10px;">
                   <el-col :span="24">
                    <span color="#abaeb5">{{$t('offering.startdatecan')}}：</span>
                    <span color="#abaeb5">{{inServForm.startdates}}</span>
                                <!-- <el-form-item prop="startdates" :label="$t('offering.startdatecan')" style="width: 65px; padding-left: 2.5px;">
                                    <el-input  disabled
                                    placeholder=""
                                    v-model="inServForm.startdates">
                               </el-input>
                    </el-form-item> -->
                            </el-col>
                </el-form-item>
               <!--地点 -->
              <el-form-item label="" style="margin-top:10px;">
                   <el-col :span="24">
                    <span color="#abaeb5">{{$t('offering.siteNamecan')}}：</span>
                    <span color="#abaeb5">{{inServForm.siteName}}</span>
                                <!-- <el-form-item prop="siteName" :label="$t('offering.siteNamecan')" style="width: 60px; padding-left: 2.5px;">
                                    <el-input  disabled
                                    placeholder=""
                                    v-model="inServForm.siteName">
                               </el-input>
                    </el-form-item> -->
                            </el-col>
              </el-form-item>
               <div class="line"></div>
               <div style="margin-top:10px;">
               <el-form-item label="" style="margin-top:10px;">
                  <el-col :span="24">
                                <el-form-item prop="cancelreasons" :label="$t('offering.cancereasons')" style="width: 60px;">
                                        <el-select v-model="inServForm.cancelreasons" style="width: 60px;" disabled
                                                   filterable :placeholder="$t('offering.cancereasonselect')">
                                            <el-option v-for="(item,index) in cancelSchedule"
                                             :key="index"
                                             :label="item.name"
                                             :value="item.code">
                                            </el-option>
                                        </el-select>
                                </el-form-item>
                            </el-col>
               </el-form-item>
               <el-form-item label="" style="margin-top:10px;">
                   <el-col :span="24">
                                <el-form-item prop="cancelremarks" :label="$t('offering.canceremarks')" style="width: 60px;">
                                    <el-input type="textarea" disabled
                                    placeholder=""
                                    v-model="inServForm.cancelremarks">
                               </el-input>
                    </el-form-item>
                            </el-col>
               </el-form-item>
               <el-form-item label="" style="margin-top:10px;">
                <el-col :span="24">
              <span color="#abaeb5">* 排期取消后，该排期下所有资源将被释放</span>
                </el-col>
               </el-form-item>
               </div>
              </el-form>
            <!-- <el-row style="float:right; margin-bottom: 60px;">
                <el-col :span="16"><div class="grid-content" /></el-col>
                <el-button @click="btnSave(datalists)"  type="primary">{{ $t("course.save") }}</el-button>
                <ZElButton @click="closeCancelDlg()" >{{ $t("course.cancel") }}</ZElButton>
            </el-row> -->
  </el-card>
</template>
<script>
import ZElButton from '../../common/button/index'
// import debounce from 'lodash/debounce'
export default {
  components: {
    ZElButton
  },
  // props: {
  //   datalists: Object
  // },
  data () {
    // let _this = this
    let _this = this
    return {
      labelPosition: 'right',
      mixinViewModuleOptions: {
        activatedIsNeed: false,
        getDataListIsPage: true,
        deleteIsBatch: true
      },
      // 课程类型
      cancelSchedule: _this.enums['cancelSchedule'],
      // eslint-disable-next-line vue/no-dupe-keys
      // datalists: {},
      currentRow: '',
      inServForm: {
        cancelremarks: '',
        cancelreasons: '',
        courseNameCn: '',
        siteName: '',
        waitingnumber: '',
        startdates: '',
        registNumber: ''
      }
    }
  },
  created () {
    // this.getDealerBeforeGetInfo(this.datalists.offeringId)
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    console.log('mounted')
  },
  activated () {
    console.log('activated')
  },
  methods: {
    getDealerBeforeGetInfo (datalist) {
      this.inServForm={}
      this.inServForm.cancelremarks = datalist.cancelremarks
      this.inServForm.cancelreasons = datalist.cancelreasons
      this.inServForm.courseNameCn = datalist.courseNameCn
      this.inServForm.registNumber = datalist.registNumber + '/' + datalist.maxNumber
      this.inServForm.startdates = this.dateFormat(datalist.startdate) + ' - ' + this.dateFormat(datalist.enddate)
      this.inServForm.waitingnumber = datalist.waitingnumber
      this.inServForm.siteName = datalist.siteName
      // this.$request.get('/learning/base/offeringinfo/getCancelView/' + datalist.offeringId
      // ).then((res, total, code, data) => {
      //   this.inServForm = data.data
      //   this.inServForm.courseNameCn = datalist.courseNameCn
      //   this.inServForm.registNumber = datalist.registNumber + '/' + datalist.maxNumber
      //   this.inServForm.startdates = this.dateFormat(datalist.startdate) + ' - ' + this.dateFormat(datalist.enddate)
      //   this.inServForm.waitingnumber = datalist.waitingnumber
      //   this.inServForm.siteName = datalist.siteName
      // }).catch(() => {
      // })
    },
    // 关闭dialog
    closeCancelDlg () {
      this.$emit('closeCancelDlgview')
    },
    dateFormat (cellValue) {
      let datetime = cellValue
      if (datetime) {
        const date = datetime.replace(/-/g, '/');
        datetime = new Date(date)
        let y = datetime.getFullYear() + '-'
        let mon = (datetime.getMonth() + 1) < 10 ? '0' + (datetime.getMonth() + 1) + '-' : (datetime.getMonth() + 1) + '-'
        let d = datetime.getDate() < 10 ? '0' + datetime.getDate() + ' ' : datetime.getDate() + ' '
        let h = datetime.getHours() < 10 ? '0' + datetime.getHours() + ':' : datetime.getHours() + ':'
        let min = datetime.getMinutes() < 10 ? '0' + datetime.getMinutes() : datetime.getMinutes()
        return y + mon + d + h + min
      }
      return ''
    }

  }
}
</script>
<style lang="scss" scoped>
.wrappDiv {
  .el-form-item__label {
    float: left;
  }
}

.el-row {
  margin-bottom: 1px;
}
.line {
    // height: 1px;
    // border-top: 1px solid #b2b0b4;
    // text-align: center;
    // margin: 1px;
    border-bottom: 1px dashed #ebeef5;
    padding-bottom: 8px;
  }
</style>
